import React from "react";

/**
 * Page lazy import component
 * 
 * @param {*} pageName Pass page name to load
 * @returns 
 */
function LazyDynamicImport(pageName) {
  const LazyImport = React.lazy(() => import(`../../../pages/${pageName}`));

  return (
    <LazyImport />
  );
}

export default LazyDynamicImport;